import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renders a group container for checkboxes, handling spacing and layout.
 * @param {Object} props - Props for the CheckboxGroup component.
 * @param {string} [props.className] - Additional CSS classes to apply.
 * @returns {JSX.Element} The rendered div element for the checkbox group.
 */
export function CheckboxGroup({ className, ...props }) {
  return (
    <div
      data-slot="control"
      {...props}
      className={clsx(
        className,
        // Basic groups
        'space-y-3',
        // With descriptions
        'has-[[data-slot=description]]:space-y-6 [&_[data-slot=label]]:has-[[data-slot=description]]:font-medium'
      )}
    />
  );
}

CheckboxGroup.propTypes = {
  className: PropTypes.string,
};
